<section
  class="approve-final-cost-success"
  aria-live="polite"
  data-testid="approve-final-cost-success-content"
>
  <img
    class="approve-final-cost-success__icon"
    src="assets/icons/success.svg"
    alt=""
    aria-hidden="true"
    data-testid="approve-final-cost-success-icon"
  />
  <p class="approve-final-cost-success__message">
    <span class="title">Success!</span><br />
    {{ message() }}
  </p>
</section>
